import { IconProps } from './index';

const MinusSign = ({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & IconProps) => {
    return (
        <svg
            width="12"
            height="3"
            viewBox="0 0 12 3"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M1 0H11C11.55 0 12 0.675 12 1.5C12 2.325 11.55 3 11 3H1C0.45 3 0 2.325 0 1.5C0 0.675 0.45 0 1 0Z"
                fill="#372E2F"
            />
        </svg>
    );
};

export default MinusSign;
